"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_cookie_1 = __importDefault(require("js-cookie"));
class MlocalStorage {
    static get(key) {
        if (localStorage.length === 0) {
            return null;
        }
        if (key) {
            const data = localStorage.getItem(key);
            if (data !== null) {
                try {
                    return JSON.parse(data);
                }
                catch (error) {
                    return data;
                }
            }
        }
        else {
            const keys = Object.keys(localStorage);
            const obj = {};
            keys.forEach((key) => {
                obj[key] = this.get(key);
            });
            return obj;
        }
        return null;
    }
    static getJSON(key) {
        return this.get(key);
    }
    static set(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    }
    static remove(key) {
        if (!key) {
            localStorage.clear();
        }
        else {
            localStorage.removeItem(key);
        }
    }
}
MlocalStorage.defaults = {};
/**
 * 浏览器内容存储
 *
 * @author HUANGE
 * @date 2020-03-03
 * @export
 * @class BroswerStorage
 */
class BroswerStorage {
    /**
     * 存储策略
     *
     * @readonly
     * @static
     * @type {(CookiesStatic | typeof MlocalStorage)}
     */
    static get storage() {
        if (this.strategy === 'cookie') {
            return this.cookie;
        }
        return this.local;
    }
    /**
     * 默认配置
     *
     * @author HUANGE
     * @date 2019-12-20
     * @static
     * @param {CookieAttributes} [attrs]
     */
    static config(attrs) {
        if (attrs) {
            this.storage.defaults = attrs;
        }
    }
    /**
     * 获取存储内容
     *
     * @author HUANGE
     * @date 2019-12-20
     * @static
     * @param {string} [key]
     * @returns 如果没有传 key 那么就获取所有的数据
     */
    static get(key) {
        if (key) {
            return this.storage.get(key);
        }
        return this.storage.getJSON(key);
    }
    /**
     * 设置存储内容
     *
     * @author HUANGE
     * @date 2019-12-20
     * @static
     * @param {string} key
     * @param {(string | object)} value
     * @param {CookieAttributes} [opts]
     */
    static set(key, value, opts) {
        this.storage.set(key, value, opts);
    }
    /**
     * 删除存储内容
     *
     * @author HUANGE
     * @date 2019-12-20
     * @static
     * @param {*} [key]
     * @param {CookieAttributes} [opts]
     */
    static remove(key, opts) {
        this.storage.remove(key, opts);
    }
}
exports.default = BroswerStorage;
/**
 * 存储策略
 *  默认使用 cookie.
 *
 * @static
 * @type {BroswerStorageStrategy}
 */
BroswerStorage.strategy = 'localstorage';
/**
 * cookies
 *
 * @static
 */
BroswerStorage.cookie = js_cookie_1.default;
/**
 * localStorage
 *
 * @static
 */
BroswerStorage.local = MlocalStorage;
